exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-selection[data-v-e421ef1c] {\n  margin-top: 20px;\n  max-width: 300px;\n}\n\n/* Fix for dropdown text visibility */\n[data-v-e421ef1c] .md-select .md-select-value {\n  color: #000 !important;\n}\n[data-v-e421ef1c] .md-select .md-menu-content .md-list-item-content {\n  color: #000 !important;\n}\n[data-v-e421ef1c] .md-input {\n  -webkit-text-fill-color: #000 !important;\n}\n[data-v-e421ef1c] .md-menu-content .md-list .md-list-item-content {\n  color: #000 !important;\n}\n", ""]);

// exports
